import { createElement } from 'react';

import { Announcement, Box, ImageMantine, Text, Title } from 'ui';
import { randomId } from 'ui/Hooks';

import { DOMJSON } from './pendoAnnouncments.types';
import { GroupedByType } from './utils/getGroupedTypes';

type HTML_ELEMENTS = 'h2' | 'h3' | 'div' | 'p' | 'img' | 'button';

const ELEMENT_DICT = {
  h2: {
    type: Title,
    props: { order: 2 },
  },
  h3: {
    type: Title,
    props: { order: 3 },
  },
  div: {
    type: Box,
    props: { order: 2 },
  },
  p: {
    type: Text,
    props: { fz: { base: 'xs', sm: 'sm' }, fw: 500 },
  },
  img: {
    type: ImageMantine,
    props: {},
  },
  button: {
    type: Announcement.Button,
    props: {},
  },
} as const;

const getElementProps = (content: DOMJSON, type: HTML_ELEMENTS) => {
  const { props } = ELEMENT_DICT[type];
  switch (type) {
    case 'img':
      return {
        ...props,
        src: content?.props?.src ?? undefined,
        key: randomId(),
      };
    case 'button':
      return {
        ...props,
      };

    default:
      return {
        key: randomId(),
        ...props,
      };
  }
};

const getContentByType = (content: GroupedByType, type: HTML_ELEMENTS) => {
  if (!content) return [];
  const contentByType = content[type];

  return contentByType;
};

const buildContentFromTypeGroup = (content: DOMJSON[] = []) => {
  return content.map((content) => content.content ?? content.markdownContent);
};

const buildElement = (
  content: DOMJSON,
  type: HTML_ELEMENTS,
  props: Record<string, unknown> = {}
) => {
  const { type: _type } = ELEMENT_DICT[type];
  const _props = getElementProps(content, type);

  const finalProps = { ..._props, ...props };
  if (type === 'img') {
    // @ts-expect-error -- _type returns different type of JSX Elements and create element doesn't like that
    return createElement(_type, finalProps);
  }
  // @ts-expect-error -- _type returns different type of JSX Elements and create element doesn't like that
  return createElement(_type, finalProps, [content.content ?? content.markdownContent]);
};

/**  */
const buildElementsFromTypeGroup = (content: DOMJSON[], type: HTML_ELEMENTS) => {
  if (!content) return [];
  return content.map((content) => buildElement(content, type));
};

const getContentButtons = (content: GroupedByType) => {
  const buttons = getContentByType(content, 'button');
  return buttons ?? [];
};

const buildPendoAnnouncement = (content?: GroupedByType) => {
  if (!content) return null;
  const titles = getContentByType(content, 'h2');
  const titles3 = getContentByType(content, 'h3');
  const pElement = getContentByType(content, 'p');
  const image = getContentByType(content, 'img');
  return {
    title: titles ? buildContentFromTypeGroup(titles) : undefined,
    children: [
      buildElementsFromTypeGroup(titles3, 'h3'),
      buildElementsFromTypeGroup(pElement, 'p'),
    ],
    image: buildElementsFromTypeGroup(image, 'img')?.[0],
  };
};

export { buildElement, buildElementsFromTypeGroup, buildPendoAnnouncement, getContentButtons };
